import { render, staticRenderFns } from "./ViewOrderModal.vue?vue&type=template&id=813bcc7c&scoped=true&"
import script from "./ViewOrderModal.vue?vue&type=script&lang=js&"
export * from "./ViewOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderModal.vue?vue&type=style&index=0&id=813bcc7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813bcc7c",
  null
  
)

export default component.exports